//  ---------------------------------------------------------------------------
//  DO NOT EDIT THIS FILE! This File was auto-generated.
//  ---------------------------------------------------------------------------
define('project/Templates',[
	'root/Assets/Templates/Html/accordion/Js/accordion',
	'root/Assets/Templates/Html/alternateImages/Js/alternateImages',
	'root/Assets/Templates/Html/contact/Js/contact',
	'root/Assets/Templates/Html/grid/Js/grid',
	'root/Assets/Templates/Html/intro/Js/intro',
	'root/Assets/Templates/Html/maps/Js/maps',
	'root/Assets/Templates/Html/swiper/Js/swiper'
], function () {
	return arguments;
});

